export default {
  dataModel: {
    types: ['pair:Sector'],
    fieldsMapping: {
      title: 'pair:label'
    }
  },
};
